import React from 'react';
import IntroSection from '../../component/introSection';
import { useMobile } from '../../hook/usePlatform';
import { ResponsiveFlexDirection } from '../../component/responsive/responsivePaddingWrapper';
import ManagerGreetings from './component/managerGreetings';
import ManagerPhoto from './component/managerPhoto';
import { lineColor } from '../../util/colors';

const IntroduceManager: React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;

  return (
    <div
      id="manager_introduce"
    >
      <IntroSection
        title="[대표 인사말]"
        content="특별한 인연을 위한 최상의 서비스, 시럽 인연과 함께 하세요"
      />
      <div
        style={{
          borderTop: border,
          position: 'relative',
        }}
      >
        <ResponsiveFlexDirection
          mobileDirection="column-reverse"
        >
          <ManagerGreetings />
          {!isMobile ? (
            <div
              style={{
                position: 'absolute',
                left: '50%',
                height: '100%',
                width: '1px',
                backgroundColor: lineColor,
              }}
            />
          ) : null}
          <ManagerPhoto />

        </ResponsiveFlexDirection>
      </div>
    </div>
  );
};

export default IntroduceManager;
